<template>
  <div class="col-md-12 text-center mt-4 mb-4 no-data-box">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "no-data-box",
  setup() {},
};
</script>
<style lang="scss" scoped>
.no-data-box {
  border: 1px solid var(--primary-bg-color);
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>
